import { MapsAPILoader } from '@agm/core';
import { Component, ElementRef, NgZone, OnInit } from '@angular/core';
import { ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { PopupModalComponent } from 'app/shared/popup-modal/popup-modal.component';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'app/App Store/state';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';

@Component({
  selector: 'app-enrolment-list',
  templateUrl: './enrolment-list.component.html',
  styleUrls: ['./enrolment-list.component.scss', "../../../../../../assets/sass/libs/datatables.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class EnrolmentListComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  @ViewChild("search")
  today = new Date();
  public searchElementRef: ElementRef;

  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 10,
    totalPages: 0
  };
  // row data
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 10;
  selectedValue = ''
  activeTab: any;
  isFilter: boolean = false
  searchByName = ''
  searchVal: any
  public columns = [
    { name: "Name", prop: "name" },
    { name: "Email", prop: "email" },
    { name: "Phone", prop: "phone" },
    { name: "Status", prop: "status" },
    { name: "Payment Due", prop: "DueAmount" },
    { name: "Created At", prop: "created_at" },
    { name: "payment_status", prop: "payment_status" },
    { name: "Course Interest", prop: "coursecatinterest_id" },
    { name: "Course Name", prop: "course_id" },
    { name: "Skill", prop: "skillsinterest_id[]" },

  ];

  // private
  private tempData = [];
  isCollapsed = false;
  imageUrl = environment.apiUrls.imageUrl;
  s3Image = environment.apiUrls.s3MediaUrl
  enrolmentId: any
  enrolementStatusId: any;
  enrolementStatus_Id: any;
  activatedData: any
  activated_Data: any
  public enrollId: any
  userId: any;
  enrolementStatus: any
  enrol_pending_data: any = []
  @ViewChild('name') inputName;
  user_role: any
  performer_event = null
  performer_list = [
    { id: 'yes', name: 'Yes' },
    { id: 'no', name: 'No' },
  ]
  student_id: any
  placement_data: any
  businessTypeCompany_Id = '6325ce10bc4b543c7a2429ad'
  selectedCollege = null
  collegeList = []
  address: string;
  latitude: number;
  longitude: number;
  zoom: number;
  private geoCoder;

  placement_model = {
    address: '',
    linkedIn: '',
    bio: '',
    placementinfo: '',
    placement_business: ''
  }
  formData = new FormData()
  fileData: File;
  imgUrl: any;
  hunting_List = []
  selectedHuntingBy = null
  selected_huntingId = ''
  key_Values = []
  sprint_id: any
  sprint_data_id: any

  guideline_data: any

  enrollment_status = [
    { name: 'Pending', _id: 'pending' },
    { name: 'Enrolled', _id: 'enrolled' },
    { name: 'Completed', _id: 'completed' }
  ]
  learningModeId = '631ad8abce5c666542591bd9'

  next_action_model = {
    next_action: '',
    last_activedate: '',
    lastresponse: '',
    notes: ''
  }
  next_action_name: any
  nextaction_tagcat_id = '63e39b572052e0098e18dfc2'
  nextactionList = []
  emp_List = [];
  typeId = "6344000d91f6bc691e775faf"
  selected_emp_referral = null
  row_id: any
  user_type: any
  empType: any = []
  referral_model = {
    refrence: '',
    report_to: '',
    notes: '',
    admin_notes: '',
  }
  emp_list = []
  row_name: any
  user_idd: any
  form_data = new FormData()
  isRefral: any = true
  modalFor = ''
  selected_mentor_buddy: string[] = []
  project_list = []
  selected_project = null
  project_cat_id = "644a5c10af0db342c32eeada"
  position_tagcat_id = "65aa77c7b4693efe6b224179"
  positionsIags_list = []
  activePage = 1
  pageNumberSubscription: Subscription
  pageNo
  batch_list = []
  select_batch = null
  currentUrl: any
  onboarding_data: any;
  batchSchedule_list = []
  selectedBatch_schedule = null
  env_url = environment.name
  prop_value: any
  editNextPaymentDate: string = '';
  minNextPaymentDate: string = new Date().toISOString().slice(0, 10);
  selectedNextPaymentRow: any = null;

  // Date of Joining properties
  editDateOfJoining: string = '';
  minDateOfJoining: string = new Date().toISOString().slice(0, 10);
  selectedDateOfJoiningRow: any = null;
  // --- Notes Modal Logic ---
  currentNoteType: 'notes' | 'admin_notes' | 'payment_notes';
  editNoteValue = '';
  selectedNoteRow: any = null;
  // --- Student Relationship Tags ---
  studentRelationshipTagCatId = '68567f77997cd994d998d411';
  studentRelationshipTags = [];
  selectedStudentRelationshipTag: any = null;
  selectedStudentRelationshipRow: any = null;

  // Enrollment Tags properties
  enrollmentTagCatId = '6854216a82cae00ca9ae2648';
  enrollmentTags = [];
  selectedEnrollmentTags: any[] = [];
  selectedEnrollmentTagsRow: any = null;

  selectedEnrollmentTagId: string = null; // For enrollment tag filter

  // Position Tags properties
  selectedPositionTagId: string = null; // For position tag filter
  isDuedatefeesFilter: boolean = false; // For due date fees filter
  isJoiningOverNotVerifiedFilter: boolean = false; // For joining date over and unverified filter

  // Student Relationship Tags properties  
  selectedRelationshipTagId: string = null; // For relationship tag filter

  showFilters = false; // collapsed by default

  course_list = [];
  selected_course: string = '';
  selectedCourseRow: any = null;

  // New chip-based filter variables
  duePaymentTags = [
    { _id: 'due', displayname: 'Due' },
    { _id: 'pending', displayname: 'Pending' },
    { _id: 'paymentDateOver', displayname: 'Payment Date Over' }
  ];
  joiningOverTags = [
    { _id: 'joiningDateOver', displayname: 'Joining Date Over' },
    { _id: 'unverified', displayname: 'Unverified' }
  ];
  selectedDuePaymentTagId: string = null;
  selectedJoiningOverTagId: string = null;

  constructor(public apiService: ApiService,
    public toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService, private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone, private route: Router,
    private store: Store<AppState>) {
    this.currentUrl = this.activatedRoute.snapshot.routeConfig.path
    this.getModeTagByCategory()
    this.locationAutoComplete()
    this.getNextActionTags()
    this.getPositionTags()
    this.getStudentRelationshipTags()
    this.getEnrollmentTags()
    this.user_role = JSON.parse(localStorage.getItem('user'))

    this.activatedRoute.queryParams
      .subscribe((params: any) => {
        this.activeTab = params['status'];
        this.pageNo = +params['page'];
        if (this.pageNo > 0) {
          this.setPage(this.pageNo);
        }
        else this.page.pageNumber = this.pageNo ? this.pageNo - 1 : 0
      })
    this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
      .subscribe(pageNumber => {
        this.page.pageNumber = pageNumber;
        if (pageNumber !== undefined) {
          this.page.pageNumber = pageNumber ? pageNumber - 1 : 0
        }
      });

    if (this.user_role.roles !== 'admin') {
      this.empType = this.user_role.employeetype.map(item => item.displayname)
      if (this.empType.includes('Managment') || this.empType.includes('HR')) {
        if (this.activeTab === 'pending' || this.activeTab === 'completed') {
          let activeTabName = this.enrollment_status.filter((item) => item._id === this.activeTab)
          this.activeEnrollmentTab(this.activeTab, activeTabName[0].name, this.pageNo ? this.pageNo : 1)
        }
        if (this.activeTab === 'Classroom') {
          let activeTabId = '6325cd99bc4b543c7a24298f'
          this.activeEnrollmentTab(activeTabId, this.activeTab, this.pageNo ? this.pageNo : 1)
        }
        if (this.activeTab === 'Online') {
          let activeTabId = '6325cdb2bc4b543c7a242996'
          this.activeEnrollmentTab(activeTabId, this.activeTab, this.pageNo ? this.pageNo : 1)
        }
        if (!this.activeTab) this.activeEnrollmentTab('pending', 'Pending', this.pageNo ? this.pageNo : 1)
        if (!this.activeTab) this.activeEnrollmentTab('6325cd99bc4b543c7a24298f', 'Classroom', this.pageNo ? this.pageNo : 1)
        if (!this.activeTab) this.activeEnrollmentTab('6325cdb2bc4b543c7a242996', 'Online', this.pageNo ? this.pageNo : 1)
        if (!this.activeTab) this.activeEnrollmentTab('completed', 'completed', this.pageNo ? this.pageNo : 1)
      }
      if (this.empType.includes('Training Moderator') || this.empType.includes('Managment')) {
        if (this.activeTab === 'pending' && this.currentUrl === 'enrollment-pending-list' || this.activeTab === 'completed' && this.currentUrl === 'enrollment-completed-list') {
          let activeTabName = this.enrollment_status.filter((item) => item._id === this.activeTab)
          this.activeEnrollmentTab(this.activeTab, activeTabName[0].name, this.pageNo ? this.pageNo : 1)
        }
        if (this.activeTab === 'Classroom' && this.currentUrl === 'enrollment-classroom-list') {
          let activeTabId = '6325cd99bc4b543c7a24298f'
          this.activeEnrollmentTab(activeTabId, this.activeTab, this.pageNo ? this.pageNo : 1)
        }
        if (this.activeTab === 'Online' && this.currentUrl === 'enrollment-online-list') {
          let activeTabId = '6325cdb2bc4b543c7a242996'
          this.activeEnrollmentTab(activeTabId, this.activeTab, this.pageNo ? this.pageNo : 1)
        }

        if (!this.activeTab && this.currentUrl === 'enrollment-pending-list') this.activeEnrollmentTab('pending', 'Pending', this.pageNo ? this.pageNo : 1)
        if (!this.activeTab && this.currentUrl === 'enrollment-classroom-list') this.activeEnrollmentTab('6325cd99bc4b543c7a24298f', 'Classroom', this.pageNo ? this.pageNo : 1)
        if (!this.activeTab && this.currentUrl === 'enrollment-online-list') this.activeEnrollmentTab('6325cdb2bc4b543c7a242996', 'Online', this.pageNo ? this.pageNo : 1)
        if (!this.activeTab && this.currentUrl === 'enrollment-completed-list') this.activeEnrollmentTab('completed', 'completed', this.pageNo ? this.pageNo : 1)

      }
      if (this.empType.includes('Teacher')) {
        if (this.activeTab === 'Classroom') {
          let activeTabId = '6325cd99bc4b543c7a24298f'
          this.activeEnrollmentTab(activeTabId, this.activeTab, this.pageNo ? this.pageNo : 1)
        }
        if (this.activeTab === 'Online') {
          let activeTabId = '6325cdb2bc4b543c7a242996'
          this.activeEnrollmentTab(activeTabId, this.activeTab, this.pageNo ? this.pageNo : 1)
        }

        if (!this.activeTab) this.activeEnrollmentTab('6325cd99bc4b543c7a24298f', 'Classroom', this.pageNo ? this.pageNo : 1)

      }

    }
    if (this.user_role.roles === 'admin') {

      if (this.activeTab === 'pending' && this.currentUrl === 'enrollment-pending-list' || this.activeTab === 'completed' && this.currentUrl === 'enrollment-completed-list') {
        let activeTabName = this.enrollment_status.filter((item) => item._id === this.activeTab)
        this.activeEnrollmentTab(this.activeTab, activeTabName[0].name, this.pageNo ? this.pageNo : 1)
      }
      if (this.activeTab === 'Classroom' && this.currentUrl === 'enrollment-classroom-list') {
        let activeTabId = '6325cd99bc4b543c7a24298f'
        this.activeEnrollmentTab(activeTabId, this.activeTab, this.pageNo ? this.pageNo : 1)
      }
      if (this.activeTab === 'Online' && this.currentUrl === 'enrollment-online-list') {
        let activeTabId = '6325cdb2bc4b543c7a242996'
        this.activeEnrollmentTab(activeTabId, this.activeTab, this.pageNo ? this.pageNo : 1)
      }

      if (!this.activeTab) this.activeEnrollmentTab('pending', 'Pending', this.pageNo ? this.pageNo : 1)
      if (!this.activeTab && this.currentUrl === 'enrollment-pending-list') this.activeEnrollmentTab('pending', 'Pending', this.pageNo ? this.pageNo : 1)
      if (!this.activeTab && this.currentUrl === 'enrollment-classroom-list') this.activeEnrollmentTab('6325cd99bc4b543c7a24298f', 'Classroom', this.pageNo ? this.pageNo : 1)
      if (!this.activeTab && this.currentUrl === 'enrollment-online-list') this.activeEnrollmentTab('6325cdb2bc4b543c7a242996', 'Online', this.pageNo ? this.pageNo : 1)
      if (!this.activeTab && this.currentUrl === 'enrollment-completed-list') this.activeEnrollmentTab('completed', 'completed', this.pageNo ? this.pageNo : 1)


    }

    let setting_data = JSON.parse(localStorage.getItem('setting-record'))
    let key_data = setting_data.filter((item) => item.key === 'Enrolments')
    this.guideline_data = key_data[0]?._id
  }
  ngOnInit() {

    this.enrollment_status = this.enrollment_status.filter(status => status.name !== "Enrolled");

    this.setAndGetEnrollmentsbyStatus()
    // this.getProjectCategory()
    this.getAllProjects()
    this.getHuntingList()
    this.getEmployeeStatusList()
    this.getFullAndPartTimeEmp()
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
  getEmpTypeTagByCategory() {
    this.apiService.getTagByTagCatgoryId('6344000d91f6bc691e775faf').subscribe((res: any) => {
      let type = res?.data?.filter((item) => item?._id == this.empType)
      this.user_type = type[0]?.name
    })
  }
  getAllEnrolments() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getAllEnrolments(this.page.pageNumber + 1, this.limitRef).subscribe((res: any) => {
      this.spinner.hide();
      this.rows = res?.data?.items
      this.page.totalPages = res?.data?.totalCount
    })
  }
  copySerialNo(serialNo: string) {
    if (serialNo) {
      navigator.clipboard.writeText(serialNo);
      // Optionally, show a toast or alert for feedback
    }
  }
  pageChangeData(page, status) {
    this.route.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { page: page.offset + 1 },
      queryParamsHandling: 'merge' // keep existing query params
    });
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    if (status === 'Classroom' && this.activeTab === 'Classroom') {
      this.activePage = page.offset + 1
      let status_id = this.enrollment_status.filter(item => item.name === 'Classroom')
      const id = status_id[0]?._id
      this.apiService.getEnrollmentByMode(id, page.offset + 1, this.limitRef, 'enrolled').subscribe((res: any) => {
        this.spinner.hide();
        this.setPage(page.offset + 1)
        this.rows = res?.data?.items
        this.page.totalPages = res?.data?.totalCount
      })
    }
    if (status === 'Online' && this.activeTab === 'Online') {
      this.activePage = page.offset + 1
      let status_id = this.enrollment_status.filter(item => item.name === 'Online')
      const id = status_id[0]?._id
      this.apiService.getEnrollmentByMode(id, page.offset + 1, this.limitRef, 'enrolled').subscribe((res: any) => {
        this.spinner.hide();
        this.setPage(page.offset + 1)
        this.rows = res?.data?.items
        this.page.totalPages = res?.data?.totalCount
      })
    }
    else {
      this.activePage = page.offset + 1
      this.apiService.getEnrollmentByStatus(status, page.offset + 1, this.limitRef).subscribe((res: any) => {
        this.spinner.hide();
        this.setPage(page.offset + 1)
        this.rows = res?.data?.items
        this.page.totalPages = res?.data?.totalCount
      })
    }

  }
  getEnrolmentFilter(data: any) {
    if (this.activeTab === 'pending' || this.activeTab === 'completed') {
      this.apiService.getFilterEnrolments('1', '1000', data, this.activeTab, this.selectedEnrollmentTagId, this.selectedPositionTagId, this.selectedRelationshipTagId, this.isDuedatefeesFilter, this.isJoiningOverNotVerifiedFilter).subscribe((res: any) => {
        this.limitRef = 1000
        this.rows = res?.data?.items
        this.page.totalPages = res?.data?.totalCount
      })
    }
    if (this.activeTab === 'Classroom' || this.activeTab === 'Online') {
      let learningModeId = null;
      const modeTag = this.enrollment_status.find(item => item.name === this.activeTab);
      if (modeTag) {
        learningModeId = modeTag._id;
      }
      this.apiService.getFilterEnrolments('1', '1000', data, 'enrolled', this.selectedEnrollmentTagId, this.selectedPositionTagId, this.selectedRelationshipTagId, this.isDuedatefeesFilter, this.isJoiningOverNotVerifiedFilter, learningModeId).subscribe((res: any) => {
        this.limitRef = 1000
        this.rows = res?.data?.items
        this.page.totalPages = res?.data?.totalCount
      })
    }
  }
  resetFilter() {
    this.inputName.nativeElement.value = null;
    this.selectedEnrollmentTagId = null;
    this.selectedPositionTagId = null;
    this.selectedRelationshipTagId = null;
    this.setAndGetEnrollmentsbyStatus()
  }

  deleteEnrolment() {
    if (this.enrolmentId) {
      this.apiService.deleteEnrolment(this.enrolmentId).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.setAndGetEnrollmentsbyStatus()
        }
        else {
          this.toastr.error(res.error)
        }
      })
    }
    else {
      this.toastr.error('something went wrong !!')
    }
  }
  // ================== Delete Alert ========================
  ConfirmColor(id: any) {
    this.enrolmentId = id
    swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes, delete it!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        this.deleteEnrolment()
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your imaginary file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your imaginary file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }

  getEnrollmentByStatus(status) {
    switch (status) {

      case 'pending':
        this.enrollmentByStatus(status);
        break;
      case 'Classroom':
        this.enrollmentByMode(status);
        break;
      case 'Online':
        this.enrollmentByMode(status);
        break;
      case 'completed':
        this.enrollmentByStatus(status);
        break;
      default:
        this.toastr.error('Invalid status:', status);
    }


  }
  enrollmentByStatus(status) {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.activePage = this.pageNo ? this.pageNo : 1
    this.apiService.getEnrollmentByStatus(status, this.activePage, this.limitRef, this.selectedEnrollmentTagId, this.selectedPositionTagId, this.selectedRelationshipTagId, this.isDuedatefeesFilter, this.isJoiningOverNotVerifiedFilter).subscribe((res: any) => {
      this.spinner.hide();
      this.rows = res?.data?.items
      this.page.totalPages = res?.data?.totalCount
      // Debug: Check if enrollment_tags data exists
      if (this.rows && this.rows.length > 0) {
        console.log('Enrollment data sample:', this.rows[0]);
        if (this.rows[0]?.enrollment_tags) {
          console.log('Enrollment tags found:', this.rows[0].enrollment_tags);
        } else {
          console.log('No enrollment_tags found in data');
        }
      }
    })
  }
  enrollmentByMode(status) {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });

    if (status === 'Classroom') {
      this.apiService.getEnrollmentByMode('6325cd99bc4b543c7a24298f', this.page.pageNumber + 1, this.limitRef, 'enrolled', this.selectedEnrollmentTagId, this.selectedPositionTagId, this.selectedRelationshipTagId, this.isDuedatefeesFilter, this.isJoiningOverNotVerifiedFilter).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.spinner.hide();
          this.rows = res?.data?.items
          this.page.totalPages = res?.data?.totalCount
          // Debug: Check if enrollment_tags data exists
          if (this.rows && this.rows.length > 0) {
            console.log('Enrollment data sample:', this.rows[0]);
            if (this.rows[0]?.enrollment_tags) {
              console.log('Enrollment tags found:', this.rows[0].enrollment_tags);
            } else {
              console.log('No enrollment_tags found in data');
            }
          }
        }
      })
    }
    if (status === 'Online') {
      this.apiService.getEnrollmentByMode('6325cdb2bc4b543c7a242996', this.page.pageNumber + 1, this.limitRef, 'enrolled', this.selectedEnrollmentTagId, this.selectedPositionTagId, this.selectedRelationshipTagId, this.isDuedatefeesFilter).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.spinner.hide();
          this.rows = res?.data?.items
          this.page.totalPages = res?.data?.totalCount
          // Debug: Check if enrollment_tags data exists
          if (this.rows && this.rows.length > 0) {
            console.log('Enrollment data sample:', this.rows[0]);
            if (this.rows[0]?.enrollment_tags) {
              console.log('Enrollment tags found:', this.rows[0].enrollment_tags);
            } else {
              console.log('No enrollment_tags found in data');
            }
          }
        }
      })
    }


  }
  // =========================================== change enrollement tabs =========================================================
  activeEnrollmentTab(tab_id, tab_name, page) {
    if (page < 1) { page = 1 }
    if (tab_name !== 'Pending' || tab_name !== 'Completed') {
      const activetab = tab_name;
      if (activetab !== '') {
        this.route.navigate(
          [],
          { relativeTo: this.activatedRoute, queryParams: { status: activetab, page: page }, queryParamsHandling: 'merge' }
        );
      }
    }
    if (tab_name === 'Pending' || tab_name === 'Completed') {
      const activetab = tab_id;
      if (activetab !== '') {
        this.route.navigate(
          [],
          { relativeTo: this.activatedRoute, queryParams: { status: activetab, page: page }, queryParamsHandling: 'merge' }
        );
      }
    }

  }

  // =========================================== programs type Tab =========================================================
  setAndGetEnrollmentsbyStatus() {
    this.activatedRoute.queryParams
      .subscribe((params: any) => {
        this.activeTab = params?.status;
        switch (this.activeTab) {
          case 'enrolled':
            this.columns.push({ name: "payment action", prop: "Payment Actions" })
            this.getEnrollmentByStatus(this.activeTab);
            break;
          case 'completed':
            this.getEnrollmentByStatus(this.activeTab);
            break
          case 'left':
            this.getEnrollmentByStatus(this.activeTab);
            break;
          case 'pending':
            this.getEnrollmentByStatus(this.activeTab);
            break;
          case 'Classroom':
            this.getEnrollmentByStatus(this.activeTab);
            break;
          case 'Online':
            this.getEnrollmentByStatus(this.activeTab);
            break;
        }
      })
  }

  CompareDate(date) {
    var currentDate = new Date()
    if (currentDate >= new Date(date)) {
      return true;
    } else {
      return false;
    }
  }
  openContent(id: any) {
    this.enrollId = id
    const modalRef = this.modalService.open(PopupModalComponent);
    modalRef.componentInstance.enrollId = this.enrollId
    modalRef.result.then((data) => {
      this.setAndGetEnrollmentsbyStatus()
    }, (reason) => {
      // This block is executed when the modal is dismissed (e.g., by clicking outside)
      // console.log('Modal dismissed:', reason);
    });

  }

  setNewPassowrd(newPassword) {
    if (this.userId) {
      let body = {
        newPassword: newPassword
      }
      this.apiService.changePassword(this.userId, body).subscribe((res: any) => {
        if (res.isSuccess === true) {
          this.toastr.success(res.message)
        }
        else {
          this.toastr.error(res.error)
        }
      })
    }
  }
  changePassword(id: any) {
    this.userId = id
    swal.fire({
      text: "Set New Password",
      input: 'text',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        if (id && this.activeTab == 'enrolled') {
          this.setNewPassowrd(result.value)
        }
      }
      else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your imaginary file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  statusUpdate2(id: any, data: any) {
    this.activated_Data = data
    this.enrolementStatus_Id = id
    const modalRef = this.modalService.open(PopupModalComponent);
    this.activatedRoute.queryParams
      .subscribe((params: any) => {
        this.activeTab = params?.status;
      })
    modalRef.componentInstance.enrolementStatus_Id = this.enrolementStatus_Id
    modalRef.componentInstance.activated_Data = this.activated_Data
    modalRef.componentInstance.completedCourse = 'Yes'
    modalRef.result.then((data) => {
      this.setAndGetEnrollmentsbyStatus()

      // on close
      this.rows = data.data.items
      this.page.totalPages = data.data.totalCount
    }, (reason) => {
      // on dismiss
      this.setAndGetEnrollmentsbyStatus()
    });
  }

  statusUpdate(id: any, data: any) {
    this.enrolementStatusId = id
    this.activatedData = data
    const modalRef = this.modalService.open(PopupModalComponent);
    this.activatedRoute.queryParams
      .subscribe((params: any) => {
        this.activeTab = params?.status;
      })
    if (this.activeTab == 'pending') {
      modalRef.componentInstance.activeTab = this.activeTab
      modalRef.componentInstance.enrolementStatusId = this.enrolementStatusId
      modalRef.componentInstance.activatedData = this.activatedData
    }
    else if (this.activeTab === 'enrolled' || this.activeTab === 'Classroom' || this.activeTab === 'Online') {
      modalRef.componentInstance.activeTab = this.activeTab
      modalRef.componentInstance.enrolementStatusId = this.enrolementStatusId
      modalRef.componentInstance.activatedData = this.activatedData
    }
    modalRef.result.then((data) => {
      // on close
      this.rows = data.data.items
      this.page.totalPages = data.data.totalCount
      this.setAndGetEnrollmentsbyStatus()
    }, (reason) => {
      // on dismiss
      this.setAndGetEnrollmentsbyStatus()
    });
  }

  dueFeesModal() {
    let dueFees = 'total due fee'
    const modalRef = this.modalService.open(PopupModalComponent);
    modalRef.componentInstance.dueFees = dueFees
    modalRef.result.then((data) => {

      // on close
    }, (reason) => {
      // on dismiss
    });

  }
  openModal(content, data, modal_id) {
    this.student_id = data?.user_id?._id
    const modalOptions: NgbModalOptions = {
      size: 'lg' // 'sm', 'lg', or 'xl'
    };
    if (!this.student_id) {
      swal.fire({
        title: 'Error',
        text: 'User id is not found!',
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-success'
        },
      })
    }

    if (this.student_id && modal_id == 'myModal1') {
      this.placement_data = data
      if (this.placement_data?.students[0]?.bio !== '' || this.placement_data?.students[0]?.placement_business?._id !== '' || this.placement_data?.students[0]?.placementinfo !== '' || this.placement_data?.user_id?.linkedIn !== '') {
        this.placement_model.bio = this.placement_data?.students[0]?.bio
        this.selectedCollege = this.placement_data?.students[0]?.placement_business?._id
        this.placement_model.placementinfo = this.placement_data?.students[0]?.placementinfo
        this.placement_model.linkedIn = this.placement_data?.user_id?.linkedIn
      }

      const modalRef = this.modalService.open(content, modalOptions);
      this.getAllCollege()

      modalRef.result.then((result) => {
      });
    }
    if (this.student_id && modal_id == 'myModal') {
      this.performer_event = data?.students[0]?.isperformer
      const modalRef = this.modalService.open(content);
      modalRef.result.then((result) => {
      }, (reason) => {
      });
    }


  }
  selectPerformer(event) {
    this.performer_event
  }
  submit() {
    let body = {
      isperformer: this.performer_event
    }
    this.apiService.updateStudent(this.student_id, body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success('Update Successfully')
        this.setAndGetEnrollmentsbyStatus()
        this.modalService.dismissAll()
      }
      else {
        this.toastr.error(res.error)
      }
    })

  }
  getAllCollege() {
    this.apiService.getBusinessByTypeId(this.businessTypeCompany_Id).subscribe((res: any) => {
      this.collegeList = res.data
    })
  }
  getCollegeId(event: any) {
    this.selectedCollege
  }
  locationAutoComplete() {
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder;

      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef?.nativeElement);
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          this.address = place.formatted_address;
          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          // set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
        });
      });
    });
  }
  updatePlacement() {
    this.placement_model.placement_business = this.selectedCollege
    this.apiService.updateStudent(this.student_id, this.placement_model).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.setAndGetEnrollmentsbyStatus()
        this.modalService.dismissAll()
      }
    })

  }
  onSelectFile(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.fileData = event.target.files[0];
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event) => {
        this.imgUrl = reader.result
      }
      this.imageUpload()
    }
  }
  imageUpload() {
    if (this.student_id) {
      this.formData.append('image', this.fileData),
        this.apiService.uploadUserImage(this.student_id, this.formData).subscribe((res: any) => {
          if (res.statusCode === 200) {
            this.setAndGetEnrollmentsbyStatus()
          }
          else {
            this.toastr.error(res.error)
          }
        })
    }
  }
  // ================== Confirm to Update Status Alert ========================
  confirmUpdateStatus(id: any, current_status) {
    let status = ''
    if (current_status === 'cancel') {
      status = 'pending'
    }
    else status = 'enrolled'
    swal.fire({
      title: 'Are you sure?',
      text: `You won't be move ${current_status} to ${status} status!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes, delete it!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        this.enrollmentStatusUpdate(id, current_status)
        swal.fire({
          icon: "success",
          title: 'Moved!',
          text: 'Your file has been moved.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  enrollmentStatusUpdate(id, current_status) {
    if (id !== '') {
      if (current_status === 'cancel') {
        let body = {
          status: 'pending'
        }

        this.apiService.updateEnrolment(id, body).subscribe((res: any) => {
          if (res.statusCode === 200) {
            this.toastr.success('enrollment status update successfully!')
            this.setAndGetEnrollmentsbyStatus()
          }
          else {
            this.toastr.error(res.error)
          }
        })
      }
      if (current_status === 'left' || current_status === 'completed') {
        let body = {
          status: 'enrolled'
        }

        this.apiService.updateEnrolment(id, body).subscribe((res: any) => {
          if (res.statusCode === 200) {
            this.toastr.success('enrollment status update successfully!')
            this.setAndGetEnrollmentsbyStatus()
          }
          else {
            this.toastr.error(res.error)
          }
        })
      }

    }
  }
  viewEnroll(row) {
    const url = ['/enrollments/enrollment-view/', row?._id];
    const target = '_blank';
    // Using window.open to open the URL in a new tab
    window.open(this.route.createUrlTree(url).toString(), target);
  }
  viewEnrollReport(row) {
    const url = 'enrollments/enrollment-report/' + row?._id;
    window.open(url, '').focus()
  }
  getHuntingList() {
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      this.hunting_List = res.items
    })
  }
  getHuntId(id, name) {
    this.selectedHuntingBy = id
    this.selected_huntingId = name
    if (this.selectedHuntingBy) {
      this.apiService.getFilterHuntingByEnrolments(this.selectedHuntingBy, this.page.pageNumber + 1, this.limitRef, this.activeTab).subscribe((res: any) => {
        if (res.statusCode === 200 && res.data.items.length > 0) {
          this.rows = res.data.items
          this.page.totalPages = res.data.totalCount[0].totalCount
        }
        else {
          this.page.totalPages = 0
        }
      })
    }
  }
  // =============LMS LINK=====================
  openInNewTab(courseId, studentId): void {
    window.open(`/student-lms?id=${courseId}`, '_blank');
  }
  sendMail(email) {
    if (email) {
      this.apiService.sendMail(email).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success(res.message)
        }
        else {
          this.toastr.error(res.error)
        }
      })
    }
  }
  onSelectFileCSV(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.fileData = event.target.files[0];
      reader.readAsDataURL(event.target.files[0]);
      this.uploadCSVFile()
    }
  }
  uploadCSVFile() {
    let formData = new FormData();
    formData.append('image', this.fileData)
    this.apiService.addEmployeeFromCSV(formData).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success('csv file upload successfully!')
        this.setAndGetEnrollmentsbyStatus()
      }
      else {
        this.toastr.error(res.error)
      }
    })
  }

  /** Midnight (00:00) of today's date for clean "past / future" compare */
  private todayMidnight = (() => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  })();

  /**
   * Returns true ⇢ date is in the past (overdue)
   */
  isOverdue(date: string | Date | null | undefined): boolean {
    if (!date) {                 // null / undefined guard
      return false;
    }
    const d = new Date(date);    // converts ISO string → Date
    d.setHours(0, 0, 0, 0);      // ignore the time part
    return d < this.todayMidnight;
  }
  openCheclistPopup(content, data, sprintId) {
    this.key_Values = Object.entries(data[0].data)
    this.sprint_data_id = data[0]._id
    this.sprint_id = sprintId
    // const modalOptions: NgbModalOptions = {
    //   size: 'lg' 
    // };
    const modalRef = this.modalService.open(content);
    modalRef.result.then((result) => {
      this.sprint_id = ''
      this.sprint_data_id = ''
      this.key_Values = []
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      this.sprint_id = ''
      this.sprint_data_id = ''
      this.key_Values = []
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  updateCheck() {
    let obj_data = Object.fromEntries(this.key_Values as any[]);
    let body = {
      data: obj_data
    }
    this.apiService.updateSprint(this.sprint_id, this.sprint_data_id, body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success('updated successfully!')
        this.modalService.dismissAll()
        this.setAndGetEnrollmentsbyStatus()
      }
      else {
        this.toastr.error(res.error)
      }
    })
  }
  openDynamicModal(key_id: string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent, modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  getModeTagByCategory() {
    this.apiService.getTagByTagCatgoryId(this.learningModeId).subscribe((res: any) => {
      let learningmode = res?.data[0]
      let learningmode1 = res?.data[1]

      this.enrollment_status.push(learningmode, learningmode1)
      const desiredStatusOrder = ['Pending', 'Classroom', 'Online', 'Completed'];
      this.enrollment_status.sort((a, b) => {
        const aIndex = desiredStatusOrder.indexOf(a.name);
        const bIndex = desiredStatusOrder.indexOf(b.name);
        return aIndex - bIndex;
      });
    })
  }
  getNextActionTags() {
    this.apiService.getTagByTagCatgoryId(this.nextaction_tagcat_id).subscribe((res: any) => {
      this.nextactionList = res?.data
    })
  }
  getChangeNextAction(event) {
    this.next_action_model.next_action
  }
  openModalForAction(content, data) {
    this.enrolmentId = data?._id
    if (data?.next_action) this.next_action_model.next_action = data?.next_action?._id || data?.next_action[0]?._id
    this.next_action_model.lastresponse = data?.lastresponse
    this.next_action_model.last_activedate = data?.last_activedate
    this.next_action_model.notes = data?.notes
    this.next_action_name = data?.name
    const options: NgbModalOptions = {
      size: 'md', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    const modalRef = this.modalService.open(content, options);
    modalRef.result.then((result) => {
    });
  }
  nextActionUpdate() {
    this.apiService.updateEnrolment(this.enrolmentId, this.next_action_model).subscribe((res: any) => {
      if (res?.statusCode === 200) {
        this.toastr.success("updated successfull")
        this.modalService.dismissAll()
        // this.setAndGetEnrollmentsbyStatus()
      }
      else this.toastr.error(res?.error)
    })
  }
  getEmployeeStatusList() {
    this.apiService.getLeadsStatusList("employeestatus").subscribe((res: any) => {
      var status = res?.data?.filter(item => item?.name === 'full_time')
      const status_id = status[0]._id
      this.getFullTimeEmpList(status_id)
    })
  }
  getFullTimeEmpList(id) {
    this.apiService.getEmployeeListByStatus(id, 1, 100).subscribe((res: any) => {
      this.emp_List = res?.items
    })
  }
  selectEmpReferralId(event) {
    this.selected_emp_referral
  }
  openReferralModal(content, id, referralBy) {
    this.row_id = id
    if (referralBy) {
      this.selected_emp_referral = referralBy
    }

    const options: NgbModalOptions = {
      size: 'md', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    const modalRef = this.modalService.open(content, options);
    modalRef.result.then((result) => {
      this.selected_emp_referral = null
      this.row_id = null
    }, (reason) => {
      this.selected_emp_referral = null
      this.row_id = null
    });
  }
  referralUpdate() {
    let body = {
      refrence_id: this.selected_emp_referral
    }
    this.apiService.updateEnrolment(this.row_id, body).subscribe((res: any) => {
      if (res?.statusCode === 200) {
        this.toastr.success('Referral updated successfull!')
        this.modalService.dismissAll()
        this.setAndGetEnrollmentsbyStatus()
      }
      else this.toastr.error(res?.error)
    })
  }
  getFullAndPartTimeEmp() {
    this.apiService.getFullPartEmployeeList(1, 100).subscribe((res: any) => {
      this.emp_list = res?.items
    })
  }
  getEmpId(event) {
    this.referral_model.report_to
  }
  openModalForReferral(content, userId, name) {
    this.row_name = name
    this.modalFor = ''
    this.referral_model.refrence = `${this.user_role.id}`
    this.user_idd = userId

    const options: NgbModalOptions = {
      size: 'md', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };

    const modalRef = this.modalService.open(content, options);

    modalRef.result.then((result) => {
      this.referral_model.report_to = null
      this.referral_model.refrence = null
      this.user_idd = null
      this.form_data = new FormData()
    }, (reason) => {
      this.referral_model.report_to = null
      this.referral_model.refrence = null
      this.user_idd = null
      this.form_data = new FormData()
    });

  }
  addReferral() {
    this.form_data.append('ref_status', 'referal')
    this.form_data.append('report_to', this.referral_model?.report_to)
    this.form_data.append('notes', this.referral_model?.notes)
    this.form_data.append('admin_notes', this.referral_model?.admin_notes)
    this.form_data.append('is_refral', this.isRefral)
    this.form_data.append('refrence_by', this.user_role.id)

    this.apiService.updateUser(this.user_idd, this.form_data).subscribe((res: any) => {
      if (res?.statusCode === 200) {
        this.toastr.success(res?.message)
        this.modalService.dismissAll()
        this.setAndGetEnrollmentsbyStatus()
      }
      else this.toastr.error(res?.error)
    })
  }
  updateRole(id) {
    if (id) {
      this.apiService.updateUserRole(id).subscribe((res: any) => {
        if (res?.statusCode === 200) {
          this.toastr.success('updated role successfull!')
          this.setAndGetEnrollmentsbyStatus()
        }
        else this.toastr.error(res?.error)
      })
    }

  }
  openMentorBuddyModal(content, id, mentor_buddy, prop) {
    this.row_id = id
    if (prop === 'Mentor') {
      this.modalFor = prop
      this.selected_mentor_buddy = mentor_buddy
      if (!mentor_buddy) {
        this.selected_mentor_buddy = null
        this.selected_emp_referral = null
      }
    }
    if (prop === 'Buddy') {
      this.modalFor = prop
      this.selected_mentor_buddy = mentor_buddy
      if (!mentor_buddy) {
        this.selected_mentor_buddy = null
        this.selected_emp_referral = null
      }
    }


    const options: NgbModalOptions = {
      size: 'md', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    const modalRef = this.modalService.open(content, options);
    modalRef.result.then((result) => {
      this.selected_mentor_buddy = null
      this.row_id = null
      this.modalFor = null
    }, (reason) => {
      this.selected_mentor_buddy = null
      this.row_id = null
      this.modalFor = null

    });
  }
  mentorBuddyId(event) {
    this.selected_mentor_buddy
  }
  mentroBuddyUpdate() {
    if (this.modalFor === 'Mentor') {
      let body = {
        mentor_id: this.selected_mentor_buddy
      }
      if (this.row_id) {
        this.apiService.updateEnrolment(this.row_id, body).subscribe((res: any) => {
          if (res?.statusCode === 200) {
            this.toastr.success(res?.message)
            this.modalService.dismissAll()
            this.setAndGetEnrollmentsbyStatus()
          }
          else this.toastr.error(res?.error)
        })
      }
    }
    if (this.modalFor === 'Buddy') {
      let body = {
        buddy_id: this.selected_mentor_buddy
      }
      if (this.row_id) {
        this.apiService.updateEnrolment(this.row_id, body).subscribe((res: any) => {
          if (res?.statusCode === 200) {
            this.toastr.success(res?.message)
            this.modalService.dismissAll()
            this.setAndGetEnrollmentsbyStatus()
          }
          else this.toastr.error(res?.error)
        })
      }
    }
  }
  //   getProjectCategory(){
  //     this.apiService.getTagByTagCatgoryId(this.project_cat_id).subscribe((res: any) => {
  //       let data = res?.data?.filter(item => item.name === 'contract')
  //       this.getAllProject(data[0]?._id)
  //     })
  // }
  // getAllProject(id){
  //   this.apiService.getJobByWorkOn(id,1,100).subscribe((res:any)=>{
  //     this.project_list = res?.data?.items
  //   })
  // }

  getAllProjects() {
    this.apiService.getAllProjects(1, 100).subscribe((res: any) => {
      this.project_list = res?.data?.items
    })
  }
  getProjectId(event) {
    this.selected_project
  }
  openContentProjectAssign(content, id, project_id) {

    this.enrollId = id
    if (project_id) {
      this.selected_project = project_id
    }
    else this.selected_project = null
    const options: NgbModalOptions = {
      size: 'md', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    const modalRef = this.modalService.open(content, options);

    modalRef.result.then((result) => {
      this.enrollId = null
    }, (reason) => {
      this.enrollId = null
    });
  }

  projectAssign() {
    let body = {
      project_assign: this.selected_project
    }
    this.apiService.updateEnrolment(this.enrollId, body).subscribe((res: any) => {
      if (res?.statusCode === 200) {
        this.toastr.success('project assigned successfull!')
        this.modalService.dismissAll()
        this.setAndGetEnrollmentsbyStatus();
      }
      else this.toastr.error(res?.error)
    })
  }
  getPositionTags() {
    this.apiService.getTagByTagCatgoryId(this.position_tagcat_id).subscribe((res: any) => {
      this.positionsIags_list = res?.data
    })
  }
  updatePosition(id, position) {
    let body = {
      position: position
    }
    if (id) {
      this.apiService.updateEnrolment(id, body).subscribe((res: any) => {
        if (res?.statusCode === 200) {
          this.toastr.success('position update successfull!')
          this.modalService.dismissAll()
          this.setAndGetEnrollmentsbyStatus();
        }
        else this.toastr.error(res?.error)
      })
    }
  }
  assignmentByStudent(id) {
    window.open(`/assignments/student-assignments/${id}`, '_blank');
  }
  openModalBatchUpdate(content, data) {
    this.getAllBatch()
    this.row_id = data?._id
    this.select_batch = data?.batch_id?._id
    const options: NgbModalOptions = {
      size: 'md', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    const modalRef = this.modalService.open(content, options);

    modalRef.result.then((result) => {
      this.select_batch = null
    }, (reason) => {
      this.select_batch = null
    });
  }
  getAllBatch() {
    this.apiService.getBatchList(1, 100).subscribe((res: any) => {
      this.batch_list = res?.data?.items;
    });
  }
  getBatchId(event) {
    this.select_batch;
  }
  updateBatch() {
    let body = {
      batch_id: this.select_batch
    }
    if (this.row_id) {
      this.apiService.updateEnrolment(this.row_id, body).subscribe((res: any) => {
        if (res?.statusCode === 200) {
          this.toastr.success('batch update successfull!')
          this.modalService.dismissAll()
          this.setAndGetEnrollmentsbyStatus();
        }
        else this.toastr.error(res?.error)
      })
    }
  }
  openModalForOnboarding(content, data) {
    this.row_id = data?.user_id?._id
    this.onBoardingByStudent(this.row_id)
    const options: NgbModalOptions = {
      size: 'lg', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    const modalRef = this.modalService.open(content, options);

    modalRef.result.then((result) => {
      this.row_id = null
    }, (reason) => {
      this.row_id = null
    });
  }
  onBoardingByStudent(id) {
    this.apiService.getAllOnboardingByStudent(id).subscribe((res: any) => {
      this.onboarding_data = res?.data[0]
    })
  }
  gotoLink(url) {
    this.validateLinkedInURL(url)
  }
  validateLinkedInURL(url) {
    const linkedInPattern = /^https?:\/\/(www\.)?linkedin\.com\/(in|pub|company)\/[a-zA-Z0-9-_%]+/;

    try {
      // Prepend https:// if missing
      if (!url.startsWith('http')) {
        url = 'https://' + url;
      }

      const urlObj = new URL(url);
      const cleanURL = urlObj.origin + urlObj.pathname; // Removing query parameters

      if (linkedInPattern.test(cleanURL)) {
        window.open(cleanURL, '_blank');
        return true;
      } else {
        this.toastr.error("Invalid LinkedIn URL. Please enter a correct LinkedIn profile URL.");
        return false;
      }
    } catch (error) {
      this.toastr.error("Invalid URL format.");
      return false;
    }
  }
  importExcel() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    let status_id
    if (this.activeTab === 'Classroom') {
      status_id = '6325cd99bc4b543c7a24298f'

    }
    if (this.activeTab === 'Online') {
      status_id = '6325cdb2bc4b543c7a242996'
    }
    if (this.activeTab !== 'Classroom' || this.activeTab! == 'Online') {
      status_id = this.activeTab
    }
    this.apiService.importExlData(status_id, 1, 5000).subscribe((res: any) => {
      this.spinner.hide();
      if (res?.isSuccess) {
        window.open(res?.data?.filePath, '_blank');
      }
    })
  }
  getBatchSchedule() {
    let tag_cat_id
    if (this.env_url === 'dev') {
      tag_cat_id = '681c9516a637a836a5f8863b'
    }
    if (this.env_url === 'prod') {
      tag_cat_id = '681c9e22e9c3d0fc4b93394b'
    }
    this.apiService.getTagByTagCatgoryId(tag_cat_id).subscribe((res: any) => {
      this.batchSchedule_list = res?.data
    })
  }
  getBatchScheduleId(event: any) {
    this.selectedBatch_schedule
  }
  openScheduleModal(content, id, prop) {
    this.getBatchSchedule()
    this.row_id = id
    this.prop_value = prop
    const options: NgbModalOptions = {
      size: 'md', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    const modalRef = this.modalService.open(content, options);
    modalRef.result.then((result) => {
      this.selectedBatch_schedule = null
    }, (reason) => {
      this.selectedBatch_schedule = null
    });
  }
  updateBatchSchedule() {
    let body = {
      batch_schedule: this.selectedBatch_schedule
    }
    this.apiService.updateEnrolment(this.row_id, body).subscribe((res: any) => {
      if (res?.isSuccess) {
        this.toastr.success('batch schedule update successfull!')
        this.modalService.dismissAll()
        this.setAndGetEnrollmentsbyStatus();
      }
      else this.toastr.error(res?.error)
    })
  }
  toggleVerification(row) {
    const id = row?._id;
    const isVerified = !row?.isVerified;
    const body = {
      isVerified: isVerified
    };
    this.apiService.updateEnrolment(id, body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success('Verification status updated successfully!');
        this.setAndGetEnrollmentsbyStatus();
      } else {
        this.toastr.error(res.error);
      }
    });
  }
  openNextPaymentDateModal(content, row) {
    this.selectedNextPaymentRow = row;
    if (row?.next_payment_date) {
      const date = new Date(row.next_payment_date);
      // Format date as YYYY-MM-DD for the input type="date"
      this.editNextPaymentDate = date.toISOString().split('T')[0];
    } else {
      this.editNextPaymentDate = this.minNextPaymentDate;
    }
    this.modalService.open(content, { size: 'md', backdrop: 'static', centered: true });
  }

  saveNextPaymentDate() {
    if (!this.selectedNextPaymentRow || !this.editNextPaymentDate) return;
    const id = this.selectedNextPaymentRow._id;
    const body = { next_payment_date: this.editNextPaymentDate };
    this.apiService.updateEnrolment(id, body).subscribe((res: any) => {
      if (res?.statusCode === 200 || res?.isSuccess) {
        this.toastr.success('Next payment date updated successfully!');
        this.modalService.dismissAll();
        this.setAndGetEnrollmentsbyStatus();
      } else {
        this.toastr.error(res?.error || 'Failed to update date');
      }
    }, err => {
      this.toastr.error('Failed to update date');
    });
  }

  // Date of Joining methods
  openDateOfJoiningModal(content, row) {
    this.selectedDateOfJoiningRow = row;
    if (row?.date_of_joining) {
      const date = new Date(row.date_of_joining);
      // Format date as YYYY-MM-DD for the input type="date"
      this.editDateOfJoining = date.toISOString().split('T')[0];
    } else {
      this.editDateOfJoining = this.minDateOfJoining;
    }
    this.modalService.open(content, { size: 'md', backdrop: 'static', centered: true });
  }

  saveDateOfJoining() {
    if (!this.selectedDateOfJoiningRow || !this.editDateOfJoining) return;
    const id = this.selectedDateOfJoiningRow._id;
    const body = { date_of_joining: this.editDateOfJoining };
    this.apiService.updateEnrolment(id, body).subscribe((res: any) => {
      if (res?.statusCode === 200 || res?.isSuccess) {
        this.toastr.success('Date of joining updated successfully!');
        this.modalService.dismissAll();
        this.setAndGetEnrollmentsbyStatus();
      } else {
        this.toastr.error(res?.error || 'Failed to update date');
      }
    }, err => {
      this.toastr.error('Failed to update date');
    });
  }

  openNotesModal(content, row, noteType) {
    this.selectedNoteRow = row;
    this.currentNoteType = noteType;
    this.editNoteValue = row[noteType] || '';
    this.modalService.open(content, { size: 'md', backdrop: 'static', centered: true });
  }

  saveNote() {
    if (!this.selectedNoteRow || !this.currentNoteType) return;
    this.apiService.updateEnrolment(this.selectedNoteRow._id, { [this.currentNoteType]: this.editNoteValue })
      .subscribe(() => {
        this.selectedNoteRow[this.currentNoteType] = this.editNoteValue;
        this.toastr.success('Note updated!');
        this.modalService.dismissAll();
      }, () => this.toastr.error('Failed to update note'));
  }

  getStudentRelationshipTags() {
    this.apiService.getTagByTagCatgoryId(this.studentRelationshipTagCatId).subscribe((res: any) => {
      this.studentRelationshipTags = res?.data;
    });
  }

  onStudentRelationshipTagChange(event: any, row: any) {
    this.selectedStudentRelationshipTag = event;
    this.selectedStudentRelationshipRow = row;
    this.updateStudentRelationshipTag(row._id, event);
  }

  updateStudentRelationshipTag(enrollmentId: string, tagId: string) {
    const updateData = {
      student_relationship_tag: tagId
    };

    this.spinner.show();
    this.apiService.updateEnrolment(enrollmentId, updateData).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.statusCode === 200) {
          this.toastr.success('Student Relationship tag updated successfully');
          // Refresh the data
          this.setAndGetEnrollmentsbyStatus();
        } else {
          this.toastr.error(res.error || 'Failed to update Student Relationship tag');
        }
      },
      (error) => {
        this.spinner.hide();
        console.error('Error updating Student Relationship tag:', error);
        this.toastr.error('Failed to update Student Relationship tag. Please try again.');
      }
    );
  }

  openStudentRelationshipModal(content: any, row: any) {
    this.selectedStudentRelationshipRow = row;
    // Handle both object and ID formats
    this.selectedStudentRelationshipTag = row?.student_relationship_tag?._id || row?.student_relationship_tag;
    this.modalService.open(content, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      windowClass: 'student-relationship-modal'
    });
  }

  getStudentRelationshipTagName(tagId: string | any): string {
    // If tagId is null or undefined, return empty string
    if (!tagId) {
      return '';
    }
    // If tagId is actually an object, return the displayname
    if (typeof tagId === 'object' && tagId !== null) {
      return tagId.displayname || tagId.name || '';
    }
    // If it's a string ID, find the tag in the list
    const tag = this.studentRelationshipTags.find(t => t._id === tagId);
    return tag ? tag.displayname : '';
  }

  saveStudentRelationshipTag() {
    if (this.selectedStudentRelationshipRow) {
      this.updateStudentRelationshipTag(this.selectedStudentRelationshipRow._id, this.selectedStudentRelationshipTag);
      this.modalService.dismissAll();
    }
  }

  // Enrollment Tags methods
  getEnrollmentTags() {
    this.apiService.getTagByTagCatgoryId(this.enrollmentTagCatId).subscribe((res: any) => {
      this.enrollmentTags = res?.data;
    });
  }
  openEnrollmentTagsModal(content: any, row: any) {
    this.selectedEnrollmentTagsRow = row;
    // Handle both array and single object formats
    if (row?.enrollment_tags) {
      if (Array.isArray(row.enrollment_tags)) {
        this.selectedEnrollmentTags = row.enrollment_tags.map((tag: any) => tag._id || tag);
      } else {
        this.selectedEnrollmentTags = [row.enrollment_tags._id || row.enrollment_tags];
      }
    } else {
      this.selectedEnrollmentTags = [];
    }
    this.modalService.open(content, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      windowClass: 'enrollment-tags-modal'
    });
  }

  updateEnrollmentTags(enrollmentId: string, tagIds: string[]) {
    const updateData = {
      enrollment_tags: tagIds
    };

    this.spinner.show();
    this.apiService.updateEnrolment(enrollmentId, updateData).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.statusCode === 200) {
          this.toastr.success('Enrollment tags updated successfully');
          // Refresh the data
          this.setAndGetEnrollmentsbyStatus();
        } else {
          this.toastr.error(res.error || 'Failed to update enrollment tags');
        }
      },
      (error) => {
        this.spinner.hide();
        console.error('Error updating enrollment tags:', error);
        this.toastr.error('Failed to update enrollment tags. Please try again.');
      }
    );
  }

  saveEnrollmentTags() {
    if (this.selectedEnrollmentTagsRow) {
      this.updateEnrollmentTags(this.selectedEnrollmentTagsRow._id, this.selectedEnrollmentTags);
      this.modalService.dismissAll();
    }
  }

  removeEnrollmentTag(tagId: string) {
    this.selectedEnrollmentTags = this.selectedEnrollmentTags.filter(id => id !== tagId);
  }

  removeEnrollmentTagFromModal(tagId: string) {
    this.selectedEnrollmentTags = this.selectedEnrollmentTags.filter(id => id !== tagId);
  }

  getEnrollmentTagName(tagId: string | any): string {
    // If tagId is null or undefined, return empty string
    if (!tagId) {
      return '';
    }
    // If tagId is actually an object, return the displayname
    if (typeof tagId === 'object' && tagId !== null) {
      return tagId.displayname || tagId.name || '';
    }
    // If it's a string ID, find the tag in the list
    const tag = this.enrollmentTags.find(t => t._id === tagId);
    return tag ? tag.displayname : '';
  }

  // Mutually exclusive chip click handlers
  onTagChipClick(tag: any, type?: string) {
    if (type === 'duePayment') {
      this.selectedDuePaymentTagId = (this.selectedDuePaymentTagId === tag._id) ? null : tag._id;
    } else if (type === 'joiningOver') {
      this.selectedJoiningOverTagId = (this.selectedJoiningOverTagId === tag._id) ? null : tag._id;
    } else {
      // fallback to enrollment tag
      if (this.selectedEnrollmentTagId === tag._id) {
        this.selectedEnrollmentTagId = null;
      } else {
        this.selectedEnrollmentTagId = tag._id;
      }
    }
    this.setAndGetEnrollmentsbyStatus();
  }
  clearTagFilter() {
    this.setPage(1);
    this.selectedEnrollmentTagId = null;
    this.setAndGetEnrollmentsbyStatus();
  }
  clearDuedatefeesFilter() {
    this.setPage(1);
    this.isDuedatefeesFilter = !this.isDuedatefeesFilter
    this.setAndGetEnrollmentsbyStatus();
  }
  clearJoiningOverNotVerifiedFilter() {
    this.setPage(1);
    this.isJoiningOverNotVerifiedFilter = !this.isJoiningOverNotVerifiedFilter
    this.setAndGetEnrollmentsbyStatus();
  }

  // Position tag chip click handlers
  onPositionTagChipClick(tag: any) {
    this.setPage(1);
    if (this.selectedPositionTagId === tag._id) {
      this.selectedPositionTagId = null;
    } else {
      this.selectedPositionTagId = tag._id;
    }
    this.setAndGetEnrollmentsbyStatus();
  }
  // onDuedatefeesFilter click handlers
  onDuedatefeesFilter() {
    this.setPage(1);
    this.isDuedatefeesFilter = !this.isDuedatefeesFilter
    this.setAndGetEnrollmentsbyStatus();
  }
  //onJoiningOverNotVerifiedFilter click handlers
  onJoiningOverNotVerifiedFilter() {
    this.setPage(1);
    this.isJoiningOverNotVerifiedFilter = !this.isJoiningOverNotVerifiedFilter
    this.setAndGetEnrollmentsbyStatus();
  }
  clearPositionTagFilter() {
    this.setPage(1);
    this.selectedPositionTagId = null;
    this.setAndGetEnrollmentsbyStatus();
  }

  // Relationship tag chip click handlers
  onRelationshipTagChipClick(tag: any) {
    this.setPage(1);
    if (this.selectedRelationshipTagId === tag._id) {
      this.selectedRelationshipTagId = null;
    } else {
      this.selectedRelationshipTagId = tag._id;
    }
    this.setAndGetEnrollmentsbyStatus();
  }

  clearRelationshipTagFilter() {
    this.setPage(1);
    this.selectedRelationshipTagId = null;
    this.setAndGetEnrollmentsbyStatus();
  }

  getAllCourses() {
    this.apiService.getCourseList(1, 1000).subscribe((res: any) => {
      this.course_list = res?.data?.items || [];
    });
  }

  openModalCourseUpdate(content, row) {
    this.getAllCourses();
    this.selectedCourseRow = row;
    this.selected_course = row?.course_id?._id;
    this.modalService.open(content, { size: 'md', backdrop: 'static' });
  }

  saveCourseUpdate() {
    if (!this.selectedCourseRow || !this.selected_course) return;
    const id = this.selectedCourseRow._id;
    const body = { course_id: this.selected_course };
    this.apiService.updateEnrolment(id, body).subscribe((res: any) => {
      if (res?.statusCode === 200 || res?.isSuccess) {
        this.toastr.success('Course updated successfully!');
        this.modalService.dismissAll();
        this.setAndGetEnrollmentsbyStatus();
      } else {
        this.toastr.error(res?.error || 'Failed to update course');
      }
    }, err => {
      this.toastr.error('Failed to update course');
    });
  }

}

